export const SURCHARGE_LABEL_KEY = 'photo_prints.premium.surcharge_label';

export type SkuPair = {
    readonly sku: string;
    readonly premiumSku: string;
};

export const toSurchargeInCents = (
    skuPairs: readonly SkuPair[],
    amounts: Record<string, number>
): number | undefined => {

    const surcharges = skuPairs
        .map(({ sku, premiumSku }) => amounts[premiumSku] - amounts[sku])
        .filter(surcharge => surcharge > 0);

    return surcharges.length > 0
        ? Math.max(...surcharges)
        : undefined;
};